import React from "react";
import { telegramHtmlToPreviewHtml, telegramHtmlToText } from "../../utils/telegramHtml";

type Props = {
    html: string;
    photoUrl?: string | null;
    videoName?: string | null;
    botName?: string;
    isZoom?: boolean;
};

export const TelegramPostPreview: React.FC<Props> = ({
    html,
    photoUrl,
    videoName,
    botName,
    isZoom,
}) => {
    const previewHtml = telegramHtmlToPreviewHtml(html);
    const plain = telegramHtmlToText(html);
    const empty = !plain && !photoUrl && !videoName && !isZoom;

    return (
        <div className="rounded-2xl overflow-hidden border border-white/10 shadow-xl bg-[#0e1621]">
            <div className="flex items-center gap-2 px-3 py-2 bg-[#17212b] border-b border-white/5">
                <div className="h-8 w-8 rounded-full bg-[#2b5278] text-white text-xs font-semibold flex items-center justify-center">
                    TG
                </div>
                <div className="min-w-0">
                    <div className="text-sm font-medium text-white truncate">
                        {botName || "Telegram"}
                    </div>
                    <div className="text-[11px] text-[#6d7f8f]">превью поста</div>
                </div>
            </div>
            <div className="p-3 min-h-[280px]">
                <div className="w-full rounded-xl overflow-hidden bg-[#182533] shadow-md">
                    {photoUrl && (
                        <img
                            src={photoUrl}
                            alt=""
                            className="w-full max-h-52 object-cover"
                        />
                    )}
                    {videoName && !photoUrl && (
                        <div className="h-28 bg-[#101922] text-[#8ea0b0] text-xs flex items-center justify-center px-3">
                            видео: {videoName}
                        </div>
                    )}
                    <div className="px-3 pt-2 pb-1">
                        {isZoom && (
                            <p className="text-[13px] leading-snug text-[#e8f4ff] mb-2">
                                Zoom-приглашение с кнопкой «Перейти»
                            </p>
                        )}
                        {empty ? (
                            <p className="text-[13px] text-[#6d7f8f] italic">
                                Текст поста появится здесь
                            </p>
                        ) : (
                            <div
                                className="tg-post-body text-[13.5px] leading-[1.45] text-[#e8f4ff] break-words"
                                dangerouslySetInnerHTML={{ __html: previewHtml }}
                            />
                        )}
                        <div className="text-right text-[11px] text-[#6d7f8f] mt-1">
                            {new Date().toLocaleTimeString("ru-RU", {
                                hour: "2-digit",
                                minute: "2-digit",
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .tg-post-body b, .tg-post-body strong { font-weight: 700; }
                .tg-post-body i, .tg-post-body em { font-style: italic; }
                .tg-post-body u { text-decoration: underline; }
                .tg-post-body s, .tg-post-body del { text-decoration: line-through; }
                .tg-post-body a { color: #6ab3f3; text-decoration: underline; }
                .tg-post-body code { font-family: ui-monospace, monospace; background: #101922; padding: 0 4px; border-radius: 4px; }
            `}</style>
        </div>
    );
};
